import { serviceApi } from '../service';

const appointmentTypeUrl = (id) => `appointment-types/${id}`;

const fetch = (id, url = undefined, options = {}, serviceId = undefined, byPassErrorCodes = []) =>
  serviceApi.fetch(
    `${appointmentTypeUrl(id)}${url ? `/${url}` : ''}`,
    options,
    serviceId,
    byPassErrorCodes,
  );
const fetchJSON = (
  id,
  url = undefined,
  options = {},
  serviceId = undefined,
  byPassErrorCodes = [],
) =>
  serviceApi.fetchJSON(
    `${appointmentTypeUrl(id)}${url ? `/${url}` : ''}`,
    options,
    serviceId,
    byPassErrorCodes,
  );

export const appointmentTypeApi = {
  appointmentTypeUrl,
  fetch,
  fetchJSON,
};
